import { t as sharedT, type TranslationKey, type Language } from '@sizzlenz/shared';

interface UseTranslationOptions {
  lang?: Language;
}

interface UseTranslationReturn {
  t: (key: TranslationKey) => string;
}

export function useTranslation(options?: UseTranslationOptions): UseTranslationReturn {
  const lang = options?.lang;

  const t = (key: TranslationKey): string => {
    return sharedT(key, lang ? { lang } : undefined);
  };

  return { t };
}
